import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./ThemeProvider";
import ScrollToTop from "./components/ScrollToTop";
import { captureAttribution } from "./lib/attribution";
import Home from "./pages/Home";
import Vaga from "./pages/Vaga";
import Candidatar from "./pages/Candidatar";
import BancoTalentos from "./pages/BancoTalentos";
import Acompanhar from "./pages/Acompanhar";
import Obrigado from "./pages/Obrigado";
import NotFound from "./pages/NotFound";
import "./index.css";

export default function App() {
  useEffect(() => { captureAttribution(); }, []);

  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vagas/:slug" element={<Vaga />} />
          <Route path="/candidatar/:slug" element={<Candidatar />} />
          <Route path="/banco-de-talentos" element={<BancoTalentos />} />
          <Route path="/acompanhar" element={<Acompanhar />} />
          <Route path="/obrigado" element={<Obrigado />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
